import React from 'react'
import cx from 'classnames'
import { AvatarRound } from '@manychat/manyui'

import cm from './Comment.module.css'

interface CommentProps {
  avatar: string | null
  comment: React.ReactNode
  postPreview?: string | null
  variant: 'default' | 'light'
}

export const Comment = ({ avatar, comment, postPreview, variant }: CommentProps) => (
  <article
    className={cx(cm.comment, {
      [cm.comment_withPostPreview]: postPreview,
      [cm.comment_light]: variant === 'light',
    })}
  >
    <AvatarRound src={avatar ?? ''} className={cm.comment__avatar} alt="" />

    <p className={cm.comment__content}>
      <span role="presentation">{comment}</span>
    </p>

    {postPreview && <img className={cm.comment__postPreview} src={postPreview} alt="" />}
  </article>
)
